import MenuJp from "@/utils/pageParts/top/jp/Menu";
import HeaderJp from "@/utils/pageParts/top/jp/Header";
import FooterJp from "@/utils/pageParts/top/jp/Footer";
import LeftMenuJp from "@/utils/pageParts/top/jp/LeftMenu";
import RightMenuJp from "@/utils/pageParts/top/jp/RightMenu";
import { useEffect, useState } from "react";
import Head from "next/head";
import styles from '@/css/index.module.css';
import PoliciesNotting from "@/utils/pageParts/top/jp/policies/Notting";
import PoliciesDefined from "@/utils/pageParts/top/jp/policies/Defined";
import PoliciesRegister, {
    PoliciesPasswordAdminer,
    PoliciesRegisterUser
} from "@/utils/pageParts/top/jp/policies/Register";
import upack from 'upack';
import { importPublicKey } from "@/lib/secureObfuscator";

export default function Policies(){
    const [menuStatus, setMenuStatus] = useState(false);
    const [url, setUrl] = useState<URL | null>(null);
    const [agreed, setAgreed] = useState<string>("");

    useEffect(() => {
        if(typeof document !== "undefined"){
            document.body.style.overflow = menuStatus ? "hidden" : "";
            return () => {
                document.body.style.overflow = "";
            };
        }
    }, [menuStatus]);

    useEffect(() => {
        if(!location) return;
        setUrl(new URL(location.href));
    }, []);
    
    useEffect(() => {
        if (!agreed || !localStorage) return;
        localStorage.setItem("terms_agree", agreed);
        if (!localStorage.getItem("terms_agree")) return;
        location.replace(`${url?.searchParams.get("redirect") ?? "/policies"}`);
    }, [agreed]);

    const handleClick = () => {
        setMenuStatus(prev => !prev);
    };
    const Agreed = async () => {
        const encoded = 
            await upack.SEncoder.encodeSEncode(
                upack.encoder.encode(Date.now().toString(36)),
                await importPublicKey(process.env.NEXT_PUBLIC_UPACK_B64KEYPAIR?.split(",")[0]!),
                0,
            )
        setAgreed(encoded);
    }
    return(
        <>
            <Head>
                <title>14nin利用規約・あさクラ利用規約</title>
                <meta name="description" content="なんと1周年!これまでを大切に、これからも進化し続けます。"/>
                <meta property="og:title" content="あさクラ利用規約" />
                <meta property="og:description" content="本利用規約には、本サービスの提供条件及び当社とユーザーの皆様との間の権利義務関係が定められています。本サービスの利用に際しては、本規約の全文をお読みいただいたうえで、本規約に同意いただく必要があります。" />
                <meta property="og:site_name" content="あさクラWiki" />
                <meta property="og:url" content={`${process.env.NEXT_PUBLIC_API_BASE_URL}/policies`} />
            </Head>
            <MenuJp handleClick={handleClick} menuStatus={menuStatus}/>
            <div className={styles.contentsWrapper} style={{ fontFamily: 'Noto Sans Japanese,sans-serif' }}>
                <HeaderJp handleClick={handleClick}/>
                <div className={styles.contents}>
                    <LeftMenuJp URL="/policies" rupages="false"/>
                    <main style={{ padding: '2rem', flex: 1 }}>
                        <header className="pEntry__header">
                            <h1>14nin利用規約・あさクラ利用規約</h1>
                        </header>
                        <p>本利用規約（以下「本規約」と言います。）には、本サービスの提供条件及び当社とユーザーの皆様との間の権利義務関係が定められています。本サービスの利用に際しては、本規約の全文をお読みいただいたうえで、本規約に同意いただく必要があります。</p>
                        <div className="p-entry__content">
                            <h2>第1条（適用）</h2>
                            <ol>
                                <li>本規約は、本サービスの提供条件及び本サービスの利用に関する当社とユーザーとの間の権利義務関係を定めることを目的とし、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されます。</li>
                                <li>本規約の内容と、その他の本規約外における他サービス利用規約、条例、法律、憲法などと衝突する場合は、<br/><strong>本規約の規定が優先して適用されるもの</strong>とします。(14nin利用規約引用)</li>
                                <li>また、本サービスを一度でも閲覧したら本規約が適応されるものとします。(2026年1月31日追加)</li>
                            </ol>
                            <h2>第2条（定義）</h2>
                            <PoliciesDefined/>
                            <h2>第3条（登録）</h2>
                            <PoliciesRegister/>
                            <h2>第4条（登録事項の変更）</h2>
                            <PoliciesRegisterUser/>
                            <h2>第5条（パスワード及びユーザーIDの管理）</h2>
                            <PoliciesPasswordAdminer/>
                            <h2>
                                <i
                                    className="fa-solid fa-ban"
                                    style={{ fontSize: "inherit" }}
                                ></i>
                                第6条（禁止事項）
                            </h2>
                            <PoliciesNotting/>
                            <h2>第7条（本サービスの停止等）</h2>
                            <ol>
                                <li>当社は、以下のいずれかに該当する場合には、登録ユーザーに事前に通知することなく、本サービスの全部または一部の提供を停止または中断することができるものとします。
                                    <ol>
                                        <li>本サービスに係るコンピューター・システムの点検または保守作業を緊急に行う場合</li>
                                        <li>コンピューター、通信回線等が事故により停止した場合</li>
                                        <li>地震、落雷、火災、風水害、停電、天災地変、サイバー攻撃などの不可抗力により本サービスの運営ができなくなった場合</li>
                                        <li>その他、当社が停止または中断を必要と判断した場合</li>
                                    </ol>
                                </li>
                                <li>当社は、本条に基づき当社が行った措置に基づきユーザーに生じた損害について一切の責任を負いません。</li>
                            </ol>
                            <h2>第8条（権利帰属）</h2>
                            <ol>
                                <li>当社ウェブサイト及び本サービスに関する知的財産権は全て当社または当社にライセンスを許諾している者に帰属しており、本規約に基づく本サービスの利用許諾は、当社ウェブサイトまたは本サービスに関する当社または当社にライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。</li>
                                <li>ユーザーは、投稿データについて、自らが投稿その他送信することについての適法な権利を有していること、及び投稿データが第三者の権利を侵害していないことについて、当社に対し表明し、保証するものとします。</li>
                                <li>ユーザーは、投稿データについて、当社に対し、世界的、非独占的、無償、サブライセンス可能かつ譲渡可能な使用、複製、配布、派生著作物の作成、表示及び実行、商用利用に関するライセンスを付与します。また、当社が利用許諾する第三者に対しても、本サービスを利用してユーザーが投稿その他送信した投稿データの使用、複製、配布、派生著作物を作成、表示及び実行することについての非独占的なライセンスを付与します。</li>
                                <li>ユーザーは、当社及び当社から権利を承継しまたは許諾された者に対して著作者人格権を行使しないことに同意するものとします。</li>
                            </ol>
                            <h2>第9条（登録抹消等）</h2>
                            <ol>
                                <li>
                                    当社は、ユーザーが、以下の各号のいずれかの事由に該当する場合は、事前に通知または催告することなく、投稿データを削除しもしくは当該ユーザーについて本サービスの利用を一時的に停止し、または登録ユーザーとしての登録を抹消、もしくはサービス利用契約を解除することができます。
                                    <ol>
                                        <li>本規約のいずれかの条項に違反した場合</li>
                                        <li>登録事項に虚偽の事実があることが判明した場合</li>
                                        <li>当社からの問いあわせその他の回答を求める連絡に対して14日間以上応答がない場合</li>
                                        <li>第3条第4項各号に該当する場合</li>
                                        <li>その他、当社が本サービスの利用、登録ユーザーとしての登録、またはサービス利用契約の継続を適当でないと判断した場合</li>
                                    </ol>
                                </li>
                                <li>当社は、本条に基づき当社が行った行為により登録ユーザーに生じた損害について一切の責任を負いません。</li>
                            </ol>
                            <h2>第10条（退会）</h2>
                            <ol>
                                <li>登録ユーザーは、当社所定の方法で当社に通知することにより、本サービスから退会し、自己の登録ユーザーとしての登録を抹消することができます。</li>
                                <li>退会後の利用者情報の取扱いについては、第14条の規定に従うものとします。</li>
                            </ol>
                            <h2>第11条（本サービスの内容の変更、終了）</h2>
                            <ol>
                                <li>当社は、当社の都合により、本サービスの内容を変更し、または提供を終了することができます。当社が本サービスの提供を終了する場合、当社はユーザーに事前に通知するものとします。</li>
                                <li>当社は、本条に基づき当社が行った措置に基づきユーザーに生じた損害について一切の責任を負いません。</li>
                            </ol>
                            <h2>第12条（保証の否認及び免責）</h2>
                            <ol>
                                <li>当社は、本サービスがユーザーの特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、ユーザーによる本サービスの利用がユーザーに適用のある法令または業界団体の内部規則等に適合すること、及び不具合が生じないことについて、何ら保証するものではありません。</li>
                                <li>当社は、当社による本サービスの提供の中断、停止、終了、利用不能または変更、ユーザーが本サービスに送信したメッセージまたは情報の削除または消失、登録ユーザーの登録の抹消、本サービスの利用による登録データの消失または機器の故障もしくは損傷、その他本サービスに関して登録ユーザーが被った損害（以下「ユーザー損害」といいます。）につき、賠償する責任を一切負わないものとします。</li>
                                <li>何らかの理由により当社が責任を負う場合であっても、当社は、ユーザー損害につき、過去12ヶ月間に登録ユーザーが当社に支払った対価の金額を超えて賠償する責任を負わないものとし、また、付随的損害、間接損害、特別損害、将来の損害及び逸失利益にかかる損害については、賠償する責任を負わないものとします。</li>
                                <li>本サービスまたは当社ウェブサイトに関連してユーザーと他のユーザーまたは第三者との間において生じた取引、連絡、紛争等については、当社は一切責任を負いません。</li>
                            </ol>
                            <h2>第13条（秘密保持）</h2>
                            <p>ユーザーは、本サービスに関連して当社がユーザーに対して秘密に取り扱うことを求めて開示した非公知の情報について、当社の事前の書面による承諾がある場合を除き、秘密に取り扱うものとします。</p>
                            <h2>第14条（利用者情報の取扱い）</h2>
                            <ol>
                                <li>当社によるユーザーの利用者情報の取扱いについては、 <a href="/privacy">別途当社プライバシーポリシー</a> の定めによるものとし、ユーザーはこのプライバシーポリシーに従って当社がユーザーの利用者情報を取扱うことについて同意するものとします。</li>
                                <li>当社は、ユーザーが当社に提供した情報、データ等を、個人を特定できない形での統計的な情報として、当社の裁量で、利用及び公開することができるものとし、ユーザーはこれに異議を唱えないものとします。</li>
                            </ol>
                            <h2>第15条（本規約等の変更）</h2>
                            <p>当社は、法務委員会委員長を通じて本規約を変更できるものとします。当社は、本規約を変更した場合には、登録ユーザーに当該変更内容を通知するものとし、当該変更内容の通知後、登録ユーザーが本サービスを利用した場合または当社の定める期間内に登録抹消の手続をとらなかった場合には、登録ユーザーは、本規約の変更に同意したものとみなします。</p>
                            <h2>第16条（連絡／通知）</h2>
                            <p>本サービスに関する問い合わせその他登録ユーザーから当社に対する連絡または通知、及び本規約の変更に関する通知その他当社から登録ユーザーに対する連絡または通知は、当社の定める方法で行うものとします。</p>
                            <h2>第17条（サービス利用契約上の地位の譲渡等）</h2>
                            <ol>
                                <li>登録ユーザーは、当社に事前の承諾なく、サービス利用契約上の地位または本規約に基づく権利もしくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。</li>
                                <li>当社は本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴いサービス利用契約上の地位、本規約に基づく権利及び義務並びに登録ユーザーの登録事項その他の顧客情報を当該事業譲渡の譲受人に譲渡することができるものとし、登録ユーザーは、かかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。</li>
                            </ol>
                            <h2>第18条（分離可能性）</h2>
                            <p>本規約のいずれかの条項またはその一部が、消費者契約法その他の法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効または執行不能と判断された規定も、継続して完全に効力を有するものとします。</p>
                            <h2>第19条（準拠法及び管轄裁判所）</h2>
                            <ol>
                                <li>本規約及びサービス利用契約の準拠法は日本法とします。なお、本サービスにおいて物品の売買が発生する場合であっても、国際物品売買契約に関する国際連合条約の適用を排除することに合意します。</li>
                                <li>本規約またはサービス利用契約に起因し、または関連する一切の紛争については、大阪地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
                            </ol>
                            <button onClick={Agreed}>
                                <span>利用規約に同意する</span>
                            </button>
                        </div>
                    </main>
                    <RightMenuJp/>
                </div>
                <FooterJp/>
            </div>
        </>
    )
}